import { render } from "./UserFormFills.vue?vue&type=template&id=31d0b0cc"
import script from "./UserFormFills.vue?vue&type=script&lang=js"
export * from "./UserFormFills.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ravanjeyhan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__